import { i18n } from "../../../i18n/i18n";

import React, { PureComponent } from 'react'
import { Bar } from 'react-chartjs-2'
import {
  BarController, BarElement, CategoryScale, Chart, LinearScale
} from 'chart.js'
import colorUtil from '../../../utils/color.util'
import itemService from '../../../services/item.service'
import workOrderService from '../../../services/workOrder.service'
import workOrderApi, { WorkOrderData } from '../../../apis/workOrder.api'
import itemApi, { ItemData } from '../../../apis/item.api'
import chartApi, {
  ChartActiveWorkOrdersResponse
} from '../../../apis/chart.api'
import Row from '../../../components/Row/Row'
import SearchPicker, {
  SearchPickerOption
} from '../../../components/SearchPicker'
import Icon from '../../../components/Icon'

interface Props { }

interface State extends ChartActiveWorkOrdersResponse {
  item: string
  workOrder: string
  itemId: string
  workOrderId: string
  items: ItemData[]
  workOrdersData: WorkOrderData[]
}

export default class ActiveWorkOrders extends PureComponent<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      item: '',
      workOrder: '',
      itemId: '',
      workOrderId: '',
      workOrders: [],
      produceds: [],
      remainings: [],
      items: [],
      workOrdersData: []
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handleSearchSelect = this.handleSearchSelect.bind(this)
    this.handleSearchBlur = this.handleSearchBlur.bind(this)
  }

  get data () {
    const { workOrders, produceds, remainings } = this.state
    const data = {
      labels: workOrders,
      datasets: [
        {
          label: 'Produced',
          data: produceds,
          backgroundColor: colorUtil.materialAt(0)
        },
        {
          label: 'Remaining',
          data: remainings,
          backgroundColor: colorUtil.materialAt(1)
        }
      ]
    }
    return data
  }

  get workOrderSearchOptions () {
    return workOrderService.searchOptions(this.state.workOrdersData)
  }

  get itemSearchOptions () {
    return itemService.searchOptions(this.state.items)
  }

  get chart () {
    Chart.register(BarController, CategoryScale, LinearScale, BarElement)
    return (
      <Bar
        data={this.data}
        options={{
          indexAxis: 'y',
          aspectRatio: 1,
          scales: {
            x: { stacked: true },
            y: {
              stacked: true,
              grid: { drawOnChartArea: false }
            }
          },
          plugins: {
            title: {
              display: true,
              align: 'center',
              text: i18n('Active Work Orders')
            },
            legend: {
              labels: {
                usePointStyle: true,
                pointStyle: 'circle',
                boxWidth: 10,
                boxHeight: 10
              }
            }
          }
        }}
        className="mb-3" />
    )
  }

  get filterFields () {
    return (
      <Row column={2}>
        <SearchPicker
          name="workOrder"
          value={this.state.workOrder}
          options={this.workOrderSearchOptions}
          label={i18n("Work order")}
          onSearch={this.handleSearch}
          onChange={this.handleInputChange}
          onSelect={this.handleSearchSelect}
          onBlur={this.handleSearchBlur} />
        <SearchPicker
          name="item"
          value={this.state.item}
          options={this.itemSearchOptions}
          label={i18n("Item")}
          onSearch={this.handleSearch}
          onChange={this.handleInputChange}
          onSelect={this.handleSearchSelect}
          onBlur={this.handleSearchBlur} />
      </Row>
    )
  }

  handleInputChange (name: string, value: string) {
    if (name === 'item') this.setState({ itemId: '', item: value })
    else if (name === 'workOrder') {
      this.setState({ workOrderId: '', workOrder: value })
    }
  }

  handleSearch (name: string, term: string) {
    if (name === 'item') {
      itemApi.search(term, items => {
        if (!items) return
        this.setState({ items })
      })
    } else if (name === 'workOrder') {
      workOrderApi.searchByCode(term, workOrdersData => {
        if (!workOrdersData) return
        this.setState({ workOrdersData })
      })
    }
  }

  handleSearchSelect (name: string, option: SearchPickerOption) {
    if (name === 'item') {
      const { value } = option
      const itemId = String(option.id)
      this.setState({ items: [], item: value, itemId }, () => {
        this.readActiveWorkOrders()
      })
    } else if (name === 'workOrder') {
      const { value } = option
      const workOrderId = String(option.id)
      this.setState(
        { workOrdersData: [], workOrder: value, workOrderId },
        () => {
          this.readActiveWorkOrders()
        })
    }
  }

  handleSearchBlur (name: string) {
    if (name === 'item') {
      this.setState({ items: [] })
    } else if (name === 'workOrder') {
      this.setState({ workOrdersData: [] })
    }
  }

  handleClear = () => {
    this.setState({
      item: '',
      workOrder: '',
      itemId: '',
      workOrderId: ''
    }, () => {
      this.readActiveWorkOrders()
    })
  }

  readActiveWorkOrders () {
    const { workOrderId, itemId } = this.state
    chartApi.activeWorkOrders(workOrderId, itemId, activeWorkOrders => {
      if (!activeWorkOrders) return
      const { workOrders, produceds, remainings } = activeWorkOrders
      this.setState({ workOrders, produceds, remainings })
    })
  }

  componentDidMount () {
    this.readActiveWorkOrders()
  }

  render () {
    return (
      <div>
        <button
          onClick={this.handleClear}
        >
          <Icon name='refresh' size='medium' color="dark" />
        </button>
        {this.chart}
        {this.filterFields}
      </div>
    )
  }
}
